import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCMS } from '../../contexts/CMSContext';

const LOGO_URL = 'https://public.readdy.ai/ai/img_res/34a777db-cb62-4f79-898c-16b8990d6b40.png';

export default function AdminPage() {
  const { adminLogin, isAdmin } = useCMS();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAdmin) navigate('/', { replace: true });
  }, [isAdmin, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    await new Promise((r) => setTimeout(r, 400));
    const ok = adminLogin(password);
    setLoading(false);
    if (ok) {
      navigate('/', { replace: true });
    } else {
      setError('Contraseña incorrecta. Intentá de nuevo.');
      setShake(true);
      setPassword('');
      setTimeout(() => { setShake(false); setError(''); }, 2500);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className={`bg-white rounded-3xl shadow-sm border border-stone-100 p-10 flex flex-col gap-7 ${shake ? 'animate-[shake_0.4s_ease-in-out]' : ''}`}>
          <div className="flex flex-col items-center gap-4 text-center">
            <img src={LOGO_URL} alt="Logo" className="h-14 w-auto object-contain" />
            <div>
              <h1 className="font-serif text-2xl font-semibold text-[#1A1A1A]">Panel de administración</h1>
              <p className="text-sm text-[#6B6B6B] mt-1">Ingresá tu contraseña para editar el sitio</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-[#1A1A1A] uppercase tracking-wide">
                Contraseña
              </label>
              <div className="relative">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••••"
                  autoFocus
                  className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#8B9D83] transition-colors pr-10"
                />
                <div className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-stone-300">
                  <i className="ri-lock-line text-base"></i>
                </div>
              </div>
              {error && (
                <p className="text-xs text-red-500 flex items-center gap-1.5 mt-0.5">
                  <i className="ri-error-warning-line"></i>
                  {error}
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={loading || !password}
              className="flex items-center justify-center gap-2 bg-[#1A1A1A] text-white font-semibold py-3.5 rounded-full hover:bg-[#333] transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap text-sm mt-1"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-loader-4-line animate-spin text-sm"></i>
                  </div>
                  Verificando...
                </>
              ) : (
                <>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-login-box-line text-sm"></i>
                  </div>
                  Ingresar
                </>
              )}
            </button>
          </form>

          <a
            href="/"
            className="text-xs text-center text-[#6B6B6B] hover:text-[#8B9D83] transition-colors cursor-pointer"
          >
            ← Volver al sitio
          </a>
        </div>

        <p className="text-center text-xs text-stone-300 mt-6">
          Esta página es solo para el administrador del sitio.
        </p>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20%        { transform: translateX(-8px); }
          40%        { transform: translateX(8px); }
          60%        { transform: translateX(-5px); }
          80%        { transform: translateX(5px); }
        }
      `}</style>
    </div>
  );
}
